/**
 * Collection of observable helpers for Svelte stores
 */

import { readable, type Readable } from "svelte/store";

/**
 * Returns a list of all prior values emitted from an observable.
 * Ignores undefined and null;
 * @param {number} limit - maximum size of accumulation. Defaults to Infinity.
 */
export function accumulate<T>(source: Readable<T>, limit: number = Infinity): Readable<T[]> {
  return readable([] as T[], (set) => {
    let items: T[] = [];

    return source.subscribe(($item) => {
      if ($item != null) {
        items = items.concat([$item]).slice(-limit);

        set(items);
      }
    });
  });
}
